import React from 'react';
import {
  Card,
  CardMedia,
  CardContent,
  CardActions,
  Typography,
  Button,
  Box,
  Chip,
} from '@mui/material';
import { Gavel, Visibility, Timer } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import AuctionCountdown from './AuctionCountdown';

const AuctionCard = ({ auction }) => {
  const navigate = useNavigate();

  const getStatusColor = () => {
    switch (auction.status) {
      case 'active':
        return 'success';
      case 'ended':
        return 'default';
      case 'draft':
        return 'warning';
      default:
        return 'default';
    }
  };

  const formatPrice = (price) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    }).format(price);
  };

  return (
    <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <CardMedia
        component="img"
        height="200"
        image={auction.item?.photos?.[0]?.url || '/placeholder-item.jpg'}
        alt={auction.item?.name}
        sx={{ objectFit: 'cover' }}
      />
      <CardContent sx={{ flexGrow: 1 }}>
        <Box display="flex" justifyContent="space-between" alignItems="start" mb={1}>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            {auction.item?.name || 'Auction Item'}
          </Typography>
          <Chip
            label={auction.status}
            size="small"
            color={getStatusColor()}
            sx={{ ml: 1 }}
          />
        </Box>

        <Typography variant="body2" color="text.secondary" mb={2} noWrap>
          {auction.item?.description}
        </Typography>

        <Box mb={2}>
          <Typography variant="caption" color="text.secondary">
            Current Bid
          </Typography>
          <Typography variant="h5" color="primary.main" fontWeight="bold">
            {formatPrice(auction.current_bid || auction.start_price)}
          </Typography>
        </Box>

        {auction.status === 'active' && (
          <Box mb={1}>
            <Typography variant="caption" color="text.secondary" display="block" mb={0.5}>
              Time Remaining
            </Typography>
            <AuctionCountdown endTime={auction.end_time} variant="chip" />
          </Box>
        )}

        <Typography variant="caption" color="text.secondary">
          {auction.bid_count || 0} bid{auction.bid_count !== 1 ? 's' : ''}
        </Typography>
      </CardContent>

      <CardActions>
        <Button
          fullWidth
          variant="contained"
          startIcon={auction.status === 'active' ? <Gavel /> : <Visibility />}
          onClick={() => navigate(`/auctions/${auction.id}`)}
        >
          {auction.status === 'active' ? 'Place Bid' : 'View Auction'}
        </Button>
      </CardActions>
    </Card>
  );
};

export default AuctionCard;
